import { IS_BROWSER } from '@lib/constants'
import Layout from '@modules/layout/templates'
import { PageTitle } from '@modules/layout/templates/PageTitle'
import { useRouter } from 'next/router'
import { ComponentType, ReactElement, useEffect, useState } from 'react'
import { NextPageWithLayout, PrefetchedPageProps } from 'types/global'

const PolicyPage: NextPageWithLayout<PrefetchedPageProps> = () => {
  const { query, replace } = useRouter()
  const policyHandle = typeof query.policy === 'string' ? query.policy : ''

  const [loaded, setLoaded] = useState(false)
  const [policy, setPolicy] = useState<BHPolicy | null>(null)

  // Create effect that dynamically imports the policy content based on `policy`
  useEffect(() => {
    if (!policyHandle) {
      return
    }

    const loadPolicyContent = async () => {
      try {
        const imported = await import(`@modules/policies/${policyHandle}`)
        const importedPolicy = imported.default
        if (importedPolicy) {
          setPolicy(() => importedPolicy)
        }
      } catch (e) {
        console.error(e)
      } finally {
        setLoaded(true)
      }
    }

    loadPolicyContent()
  }, [policyHandle])

  if (!loaded) {
    return <div>Loading...</div>
  }

  // Redirect to 404 if policy is not found
  if (policy === null) {
    replace('/404')
    return <></>
  }

  return (
    <div className="flex justify-center mt-8 p-10">
      <div className="flex flex-col max-w-5xl">
        <PageTitle title={`${policy.title.toUpperCase()}`} />
        <div className="mt-4 mx-auto max-w-4xl">
          <div className="max-w-[680px] space-y-4">{policy.content}</div>
        </div>
      </div>
    </div>
  )
}

PolicyPage.getLayout = (page: ReactElement) => {
  return <Layout>{page}</Layout>
}

export default PolicyPage
